<template>
    <EditForm :passId="$route.params.id"  />
</template>

<script>
// @ is an alias to /src
import EditForm from "@/components/EditForm.vue";

export default {
  name: "home",
  components: {
    EditForm
  }
};
</script>
